<style lang="scss"></style>

<template>
  <div class="add-app-modal">

    <p>Applying a ban will prevent this {{ $options.filters.term('prisoner') }} from receiving any digital mail from all of their contacts. <b>It will also reject any post or replies that are currently awaiting approval.</b></p>
    <validation-observer ref="observer" v-slot="{ handleSubmit }">
      <b-form @submit.stop.prevent="handleSubmit(addKeyword)">

        <section class="mb-2">
          <validation-provider
            v-slot="validationContext"
            :name="`${$options.filters.term('prisoner')} Number`"
            :rules="{ required: true, prisonerNumberFormat: true }"
          >
            <label>{{ $options.filters.term('prisoner') | capEachWord }} Number</label>
            <b-form-input
              v-model="restriction.prisoner_number"
              :disabled="!!$props.prisonerNumber"
              :state="getValidationState(validationContext)"
              class="mb-1"
              :placeholder="'Enter ' + $options.filters.term('prisoner') + ' number'"
            />

            <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
          </validation-provider>

        </section>

        <section class="mb-2">
          <label>Reason</label>
          <b-form-textarea
            v-model="restriction.reason"
            class="mb-1"
            placeholder="Enter a reason for the ban...."
          />
        </section>

        <section class="d-inline-flex full-width mt-2">
          <div class="ui-spacer" />
          <b-button class="mr-2" @click="$emit('close', true)">Cancel</b-button>
          <b-button :disabled="submitting" type="submit" variant="primary">Apply Ban</b-button>
        </section>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars

import DigitalMailRestrictionsService from '@/services/DigitalMailRestrictionsService';

export default {
  components: {},
  props: {
    prisonerNumber: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      submitting: false,
      restriction: {
        prisoner_number: this.$props.prisonerNumber,
        reason: '',
      },
    }
  },
  mounted() {
  },
  methods: {
    addKeyword() {
      this.submitting = true
      DigitalMailRestrictionsService.create(this.restriction)
        .then(() => {
          this.$toast.success('Prisoner Ban Applied', {
            toastClassName: ['toast-std', 'success-toast'],
          })

          this.$emit('refresh', true)
        })
        .catch(err => {
          let errorMsg = 'Could not apply prisoner ban, please refresh and try again'
          if (err.response && err.response.data && err.response.data.error === 'ENTITY_ALREADY_EXISTS') {
            errorMsg = `Could not apply prisoner ban as one already exists for this ${this.$options.filters.term('prisoner')}`;
          }
          console.log('error applying prisoner ban', err)
          this.$toast.error(errorMsg, {
            toastClassName: ['toast-std', 'warning-toast'],
          })
        })
        .finally(() => {
          this.submitting = false
        })
    },
    getValidationState({
      dirty,
      validated,
      valid = null,
    }) {
      return dirty || validated ? valid : null
    },
  },
}
</script>
